import { FormatAmount } from "app/utils/utility.service";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Fragment } from "react";

const HomeValueTable = ({ reportData, showMore, showButton, handleShowMore, lastData }) => {
    return (
        <div className="HomeValueTable mb-4">
        {reportData &&
        reportData.length > 0 && (
            <Fragment>
                <div className="flex">
                    <h3 className="ml-2" style={{ flex: "0.5" }}>
                        Rental Increase - Rental Real Estate
                    </h3>
                    <h3>Owned Real Estate</h3>
                </div>
                <DataTable value={reportData} responsiveLayout="scroll">
                    <Column field="year" 
                    header="Year"
                    ></Column>
                    <Column
                        field="rent"
                        header="Rent"
                        body={(rowData) =>
                            rowData.rent
                                ? FormatAmount(parseInt(rowData.rent))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="annualRent"
                        header="Annual"
                        body={(rowData) =>
                            rowData.annualRent
                                ? FormatAmount(parseInt(rowData.annualRent))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="mortgage"
                        header="Mortgage"
                        body={(rowData) =>
                            rowData.mortgage
                                ? FormatAmount(parseInt(rowData.mortgage))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="propertyTax"
                        header="P. Tax"
                        body={(rowData) =>
                            rowData.propertyTax
                                ? FormatAmount(parseInt(rowData.propertyTax))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="expenses"
                        header="Expenses"
                        body={(rowData) =>
                            rowData.expenses
                                ? FormatAmount(parseInt(rowData.expenses))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="annualExpense"
                        header="Annual"
                        body={(rowData) =>
                            rowData.annualExpense
                                ? FormatAmount(parseInt(rowData.annualExpense))
                                : "0"
                        }
                    ></Column>
                    <Column field="mid" header="MID" body={(rowData) =>
                            rowData.mid
                                ? FormatAmount(parseInt(rowData.mid))
                                : "0"
                        }></Column>
                    <Column
                        field="nett"
                        header="Net"
                        body={(rowData) =>
                            rowData.nett
                                ? FormatAmount(parseInt(rowData.nett))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="appreciation"
                        header="Appreciation"
                        body={(rowData) =>
                            rowData.appreciation
                                ? FormatAmount(parseInt(rowData.appreciation))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="beforeTotalEquity"
                        header="Before Equity"
                        body={(rowData) =>
                            rowData.beforeTotalEquity
                                ? FormatAmount(
                                      parseInt(rowData.beforeTotalEquity)
                                  )
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="totalEquity"
                        header="Total Equity"
                        body={(rowData) =>
                            rowData.totalEquity
                                ? FormatAmount(parseInt(rowData.totalEquity))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="totalHomeValue"
                        header="Total Home Value"
                        body={(rowData) =>
                            rowData.totalEquity
                                ? FormatAmount(parseInt(rowData.totalHomeValue))
                                : "0"
                        }
                    ></Column>
                </DataTable>
                <div className="flex justify-content-end p-4">
                    {showButton && (
                        <Fragment>
                            {!showMore ? (
                                <Button
                                    className="p-button-raised p-button-warning mr-2"
                                    onClick={handleShowMore}
                                >
                                    Show More
                                </Button>
                            ) : (
                                <Button
                                    className="p-button-raised p-button-warning mr-2"
                                    onClick={handleShowMore}
                                >
                                    Show Less
                                </Button>
                            )}
                        </Fragment>
                    )}
                </div>
                {!showMore && showButton && (
                <DataTable className="lastRow" value={lastData} responsiveLayout="scroll">
                    <Column header="Year" field="year"></Column>
                    <Column
                        field="rent"
                        header="Rent"
                        body={(rowData) =>
                            rowData.rent
                                ? FormatAmount(parseInt(rowData.rent))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="annualRent"
                        header="Annual"
                        body={(rowData) =>
                            rowData.annualRent
                                ? FormatAmount(parseInt(rowData.annualRent))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="mortgage"
                        header="Mortgage"
                        body={(rowData) =>
                            rowData.mortgage
                                ? FormatAmount(parseInt(rowData.mortgage))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="propertyTax"
                        header="P. Tax"
                        body={(rowData) =>
                            rowData.propertyTax
                                ? FormatAmount(parseInt(rowData.propertyTax))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="expenses"
                        header="Expenses"
                        body={(rowData) =>
                            rowData.expenses
                                ? FormatAmount(parseInt(rowData.expenses))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="annualExpense"
                        header="Annual"
                        body={(rowData) =>
                            rowData.annualExpense
                                ? FormatAmount(parseInt(rowData.annualExpense))
                                : "0"
                        }
                    ></Column>
                    <Column header="MID" field="mid" body={(rowData) =>
                            rowData.mid
                                ? FormatAmount(parseInt(rowData.mid))
                                : "0"
                        }></Column>
                    <Column
                        field="nett"
                        header="Net"
                        body={(rowData) =>
                            rowData.nett
                                ? FormatAmount(parseInt(rowData.nett))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="appreciation"
                        header="Appreciation"
                        body={(rowData) =>
                            rowData.appreciation
                                ? FormatAmount(parseInt(rowData.appreciation))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="beforeTotalEquity"
                        header="Before Equity"
                        body={(rowData) =>
                            rowData.beforeTotalEquity
                                ? FormatAmount(
                                      parseInt(rowData.beforeTotalEquity)
                                  )
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="totalEquity"
                        header="Total Equity"
                        body={(rowData) =>
                            rowData.totalEquity
                                ? FormatAmount(parseInt(rowData.totalEquity))
                                : "0"
                        }
                    ></Column>
                    <Column
                        field="totalHomeValue"
                        header="Total Home Value"
                        body={(rowData) =>
                            rowData.totalEquity
                                ? FormatAmount(parseInt(rowData.totalHomeValue))
                                : "0"
                        }
                    ></Column>
                </DataTable>
                )}
                <div className="printSeparation"></div>
            </Fragment>
        )}
        </div>
    );
};

export default HomeValueTable;
